import React from "react";

const PHONE = "12428016950";
const MESSAGE = "Hello SAVNT — I'd like to enquire about a piece.";

export function WhatsAppFab() {
    const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(MESSAGE)}`;

    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="whatsapp-fab"
            aria-label="Chat with SAVNT on WhatsApp"
            className="fixed bottom-[56px] sm:bottom-[56px] right-6 z-[70] group"
        >
            <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping" />
            <span className="relative flex items-center justify-center h-14 w-14 rounded-full bg-[#25D366] shadow-[0_8px_28px_rgba(37,211,102,0.45)] ring-1 ring-white/10 transition-transform duration-300 group-hover:scale-110">
                <svg
                    viewBox="0 0 32 32"
                    className="h-7 w-7 text-white"
                    fill="currentColor"
                    aria-hidden="true"
                >
                    <path d="M19.11 17.39c-.27-.13-1.6-.79-1.85-.88-.25-.09-.43-.13-.61.14-.18.27-.7.88-.86 1.06-.16.18-.32.2-.59.07-.27-.14-1.14-.42-2.18-1.34-.81-.72-1.35-1.61-1.51-1.88-.16-.27-.02-.41.12-.55.12-.12.27-.32.4-.48.13-.16.18-.27.27-.45.09-.18.04-.34-.02-.48-.07-.13-.61-1.47-.84-2.01-.22-.53-.45-.46-.61-.46-.16 0-.34-.02-.52-.02-.18 0-.48.07-.74.34-.25.27-.96.94-.96 2.29s.99 2.66 1.12 2.84c.13.18 1.93 2.94 4.67 4.12.65.28 1.16.45 1.55.58.65.21 1.24.18 1.71.11.52-.08 1.6-.65 1.83-1.28.23-.63.23-1.16.16-1.28-.07-.11-.25-.18-.52-.32zM16.02 4C9.39 4 4 9.39 4 16.02c0 2.12.55 4.18 1.6 6L4 28l6.18-1.62c1.76.96 3.74 1.47 5.76 1.47h.01c6.63 0 12.02-5.39 12.02-12.02 0-3.21-1.25-6.23-3.52-8.5C22.18 5.25 19.15 4 16.02 4zm6.94 18.97c-.29.82-1.68 1.57-2.36 1.67-.6.09-1.37.13-2.21-.14-.51-.16-1.17-.38-2.02-.74-3.55-1.53-5.87-5.11-6.05-5.35-.18-.24-1.45-1.93-1.45-3.69 0-1.76.92-2.62 1.25-2.98.33-.36.71-.45.95-.45.24 0 .47.002.68.012.22.01.51-.08.8.61.29.71.99 2.46 1.08 2.64.09.18.15.4.03.64-.12.24-.18.39-.36.6-.18.21-.38.47-.54.63-.18.18-.37.38-.16.74.21.36.94 1.55 2.01 2.51 1.39 1.24 2.55 1.62 2.91 1.81.36.18.57.15.79-.09.21-.24.91-1.06 1.15-1.43.24-.36.48-.3.81-.18.33.12 2.1.99 2.46 1.17.36.18.6.27.69.42.09.16.09.91-.2 1.73z" />
                </svg>
            </span>
        </a>
    );
}

export default WhatsAppFab;
